import { BaseEntity, Entity as DecribeEntity, RelationList } from '@avangard/utils/entity';

import { StudentOnlineApplicationDocumentType, SoaDocumentStatus } from '@modules/types/graphql';
import { SoaDocumentFileEntityList } from './soa-document-file.entity-list';

import type { StudentOnlineApplicationDocument } from '@modules/types/graphql';
import type { SoaDocumentFileEntity } from './soa-document-file.entity';

export type Entity = Partial<StudentOnlineApplicationDocument> | null;

@DecribeEntity('SoaDocumentEntity')
class SoaDocumentEntity extends BaseEntity {
    id: string;
    type: StudentOnlineApplicationDocumentType;
    name: string;
    description: string | null;
    hint: string | null;
    template: string;
    example: string;
    status: SoaDocumentStatus;

    @RelationList(() => SoaDocumentFileEntityList)
    files: SoaDocumentFileEntity[];

    // client side
    isTemplate: boolean;

    constructor(entity: Entity) {
        super(entity);

        this.id = entity?.id ?? '';
        this.type = entity?.type ?? StudentOnlineApplicationDocumentType.identity;
        this.name = entity?.name ?? '';
        this.description = entity?.description || null;
        this.hint = entity?.hint || null;
        this.template = entity?.template ?? '';
        this.example = entity?.example ?? '';
        this.status = entity?.status ?? SoaDocumentStatus.pending;

        if (entity === null) {
            this.isTemplate = true;
        }
    }

    getStatusTitle() {
        switch (this.status) {
            case SoaDocumentStatus.pending:
                return 'Ждет загрузки';

            case SoaDocumentStatus.review:
                return 'На проверке';

            case SoaDocumentStatus.correction:
                return 'На исправлении';

            case SoaDocumentStatus.approved:
                return 'Одобрено';
        }
    }

    canUploadFiles() {
        return [
            SoaDocumentStatus.pending,
            SoaDocumentStatus.review,
            SoaDocumentStatus.correction,
        ].includes(this.status);
    }
}

export { SoaDocumentEntity };
